// @mui material components
import Grid from "@mui/material/Grid";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import breakpoints from "assets/theme/base/breakpoints";
// Overview page components
import Header from "layouts/profile/components/Header";

// Data

// Images

import { useEffect, useState } from "react";
import { AppBar, Icon } from "@mui/material";
import TabPanel from "components/TabPanel";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserInfo } from "services/apiService";
import { getAccountPost } from "services/apiService";
import { useMediaQuery } from "react-responsive";
import { getListNftUser } from "services/apiService";
import nftSvg from "assets/images/NFT.svg";
import MDAvatar from "components/MDAvatar";
import { updateUser } from "services/apiService";
import InfiniteScroll from "react-infinite-scroll-component";
import Grid4x4Icon from "@mui/icons-material/Grid4x4";
import EventIcon from "@mui/icons-material/Event";
import NfcIcon from "@mui/icons-material/Nfc";
import SpinLoader from "components/SpinLoader";
import ProfileLoader from "components/SkeletonLoader/profileLoader";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { useDispatch, useSelector } from "react-redux";
import { profileDataReducer } from "Store/slices/profileDataSlice";
import { profilePostReducer } from "Store/slices/profileDataSlice";
import { profileNftReducer } from "Store/slices/profileDataSlice";
import { profilePostReducerPlus } from "Store/slices/profileDataSlice";
import { profileNftReducerPlus } from "Store/slices/profileDataSlice";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function Overview() {
  const dispatch = useDispatch();

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const {
    profileData,
    profilePost,
    profilePostPageNumber,
    profilePostCount,
    profileNft,
    profileNftPageNumber,
    profileNftCount,
    isLoadingProfile,
  } = useSelector((state) => state.profileData);
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  // const [profilePost, setProfilePost] = useState([]);
  // const [profileNft, setProfileNft] = useState([]);
  const [profileInfo, setProfileInfo] = useState([]);

  const [mintDialogBoolean, setMintDialogBoolean] = useState(false);
  const [mintNftData, setMintNftData] = useState("");
  const [changePriceBoolean, setChangePriceBoolean] = useState(false);
  const [statusUpdateBoolean, setStatusUpdateBoolean] = useState(true);
  const [statusLoader, setStatusLoader] = useState(false);

  const [postCount, setPostCount] = useState(0);
  const [nftCount, setNftCount] = useState(0);

  const [pageLoader, setPageLoader] = useState(true);
  const [tabsLoader, setTabsLoader] = useState(true);
  const [postPageNumber, setPostPageNumber] = useState(1);
  const [nftPageNumber, setNftPageNumber] = useState(0);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  useEffect(() => {
    fetchProfileData();
  }, [searchParams.get("username"), statusUpdateBoolean]);

  const fetchProfileData = async () => {
    setPageLoader(true);
    const getProfileData = await getUserInfo(searchParams.get("username"));

    // console.log("getProfileData", getProfileData);

    if (getProfileData.status === 200) {
      dispatch(profileDataReducer(getProfileData.data));
      setPageLoader(false);
    }

    const profilePostRes = await getAccountPost(
      searchParams.get("username"),
      1
    );
    // console.log("profilePostRes", profilePostRes);
    if (profilePostRes.status === 200) {
      dispatch(profilePostReducer(profilePostRes.data));
    }

    const profileNftRes = await getListNftUser(getProfileData.data.email, 0);
    // console.log("profileNftRes", profileNftRes);
    if (profilePostRes.status === 200) {
      dispatch(profileNftReducer(profileNftRes.data));
    }

    setTabsLoader(false);
  };

  const refresher = () => {
    setStatusUpdateBoolean((prev) => !prev);
  };

  const fetchUserDetailsOnly = async () => {
    // setPageLoader(true);

    const userInfoRes = await getUserInfo(searchParams.get("username"));
    // console.log("profileInfoRes", userInfoRes);
    setProfileInfo(userInfoRes);
    // setPageLoader(false);
  };

  const fetchUserDetails = async () => {
    setPageLoader(true);
    setTabsLoader(true);
    // const userInfoRes = await getUserInfo(searchParams.get("username"));
    // console.log("profileInfoRes", userInfoRes);

    // setProfileInfo(userInfoRes.data);
    setPageLoader(false);

    // const profilePostRes = await getAccountPost(
    //   searchParams.get("username"),
    //   postPageNumber
    // );
    // console.log("profilePostRes", profilePostRes);
    // if (profilePostRes.length > 0) {
    //   setPostCount(profilePostRes[0].countPost);
    // }

    // setProfilePost(profilePostRes);
    // setPostPageNumber((prev) => prev + 1);

    // const profileNftRes = await getListNftUser(
    //   userAppInfo?.email,
    //   nftPageNumber
    // );

    // if (profileNftRes.length > 0) {
    //   setNftCount(profileNftRes[0].countNFT);
    // }

    // setProfileNft(profileNftRes);
    // setTabsLoader(false);
    // setNftPageNumber((prev) => prev + 1);
  };

  const fetchMorePost = async (number) => {
    // console.log("pageNumberINSIDE1", postPageNumber);

    console.log("here", number);

    const profilePostResNew = await getAccountPost(
      searchParams.get("username"),
      number
    );
    if (profilePostResNew.status === 200) {
      dispatch(profilePostReducerPlus(profilePostResNew.data));
    }
    // console.log("profilePostResNew", profilePostResNew);
    // setProfilePost(profilePost.concat(profilePostResNew));
    // console.log("pageNumberINSIDE2", postPageNumber);
    // setPostPageNumber((prev) => prev + 1);
  };

  const fetchMoreNft = async (number) => {
    // console.log("pageNumberINSIDE1", nftPageNumber);
    const profileNftResNew = await getListNftUser(profileData.email, number);
    if (profileNftResNew.status === 200) {
      dispatch(profileNftReducerPlus(profileNftResNew.data));
    }
    // // console.log("profilePostResNew", profileNftResNew);
    // setProfileNft(profileNft.concat(profileNftResNew));
    // // console.log("pageNumberINSIDE2", nftPageNumber);
    // setNftPageNumber((prev) => prev + 1);
  };

  const handleFollowUnfollow = async () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setStatusLoader(true);
    if (profileData.isFollowing) {
      const updateData = {
        removeUser: searchParams.get("username"),
      };
      const updateUserRes = await updateUser(updateData);
      // console.log("updateUserRes1", updateUserRes);
      setStatusUpdateBoolean((prev) => !prev);
      setStatusLoader(false);
    } else {
      const updateData = {
        followers: searchParams.get("username"),
      };
      const updateUserRes = await updateUser(updateData);
      // console.log("updateUserRes2", updateUserRes);
      setStatusUpdateBoolean((prev) => !prev);
      setStatusLoader(false);
    }
  };

  const handlePostDetail = (postId) => {
    navigate(
      `/profile-post-detail/?username=${searchParams.get(
        "username"
      )}&type=post&postId=${postId}`
      // { state: profilePost }
    );
  };

  const handleNftDetail = (nftId) => {
    navigate(
      `/profile-post-detail/?type=nft&username=${searchParams.get(
        "username"
      )}&type=nft&nftId=${nftId}`
    );
  };

  const handleCloseMintDialog = () => {
    setMintDialogBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ marginBottom: "2rem" }}>
        {!pageLoader && !isLoadingProfile ? (
          <MDBox>
            <Header
              // profileData={profileInfo}
              followUnfollowTrigger={handleFollowUnfollow}
              statusLoader={statusLoader}
              refresher={refresher}
            />

            <MDBox>
              <Grid container sx={{ justifyContent: "center" }}>
                <AppBar position="static" sx={{}}>
                  <Tabs
                    // inkBarStyle={{ backgroundColor: "red" }}
                    value={tabValue}
                    onChange={handleSetTabValue}
                  >
                    <Tab label="Posts" icon={<Grid4x4Icon />} />
                    <Tab label="NFT" icon={<NfcIcon />} />
                    <Tab label="Events" icon={<EventIcon />} />
                  </Tabs>
                </AppBar>
                <MDBox sx={{ width: "100%" }}>
                  <TabPanel value={tabValue} index={0}>
                    <InfiniteScroll
                      dataLength={profilePost.length}
                      next={() => fetchMorePost(profilePostPageNumber + 1)}
                      hasMore={profilePost.length < profilePostCount}
                      loader={
                        <MDBox sx={{ textAlign: "center" }}>
                          <SpinLoader />
                        </MDBox>
                      }
                    >
                      {tabsLoader ? (
                        <ProfileLoader />
                      ) : profilePost.length > 0 ? (
                        <MDBox
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: "5px",
                            rowGap: "5px",
                          }}
                        >
                          {profilePost.map((item, idx) => (
                            <MDBox
                              key={idx}
                              sx={{
                                height: isDesktopOrLaptop ? "200px" : "110px",
                                width: isDesktopOrLaptop ? "200px" : "110px",
                                position: "relative",
                              }}
                              onClick={() => handlePostDetail(item._id)}
                            >
                              {item.postType === "video" && (
                                <MDBox
                                  sx={{ position: "absolute", left: "0px" }}
                                >
                                  <MDTypography fontSize="30px">
                                    <PlayArrowIcon />
                                  </MDTypography>
                                </MDBox>
                              )}

                              {item.nftStatus === "true" && (
                                <MDBox
                                  sx={{
                                    position: "absolute",
                                    right: "0px",
                                    top: "0px",
                                    padding: "0.5rem",
                                  }}
                                >
                                  <MDAvatar
                                    src={nftSvg}
                                    size={isTabletOrMobile ? "xs" : "sm"}
                                    imgProps={{
                                      style: {
                                        height: "100%",
                                        width: "100%",
                                      },
                                    }}
                                  />
                                </MDBox>
                              )}

                              <img
                                src={
                                  item.postType === "video"
                                    ? item.thumbnail
                                    : item.photo
                                }
                                style={{ objectFit: "cover" }}
                                height="100%"
                                width="100%"
                                alt="picture"
                              />
                            </MDBox>
                          ))}
                        </MDBox>
                      ) : (
                        <MDBox sx={{ textAlign: "center" }}>
                          <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                            No Posts Added
                          </MDTypography>
                        </MDBox>
                      )}
                    </InfiniteScroll>
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    <InfiniteScroll
                      dataLength={profileNft.length}
                      next={() => fetchMoreNft(profileNftPageNumber + 1)}
                      hasMore={profileNft.length < profileNftCount}
                      loader={
                        <MDBox sx={{ textAlign: "center" }}>
                          <SpinLoader />
                        </MDBox>
                      }
                    >
                      {tabsLoader ? (
                        <ProfileLoader />
                      ) : profileNft.length > 0 ? (
                        <MDBox
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: "5px",
                            rowGap: "5px",
                          }}
                        >
                          {profileNft.map((item, idx) => (
                            <MDBox
                              key={idx}
                              sx={{
                                position: "relative",
                                height: isDesktopOrLaptop ? "200px" : "110px",
                                width: isDesktopOrLaptop ? "200px" : "110px",
                              }}
                              onClick={() => handleNftDetail(item._id)}
                            >
                              {item.sellingStatus === "Not for sale" ? (
                                <MDBox
                                  sx={{
                                    position: "absolute",
                                    right: "0px",
                                    top: "0px",
                                    padding: "0.5rem",
                                  }}
                                >
                                  <MDAvatar
                                    src={nftSvg}
                                    size={isTabletOrMobile ? "xs" : "sm"}
                                    imgProps={{
                                      style: {
                                        height: "100%",
                                        width: "100%",
                                      },
                                    }}
                                  />
                                </MDBox>
                              ) : (
                                <MDBox
                                  sx={{
                                    position: "absolute",
                                    right: "0px",
                                    top: "0px",
                                  }}
                                >
                                  <MDTypography color="singh" fontSize="30px">
                                    <LocalOfferOutlinedIcon />
                                  </MDTypography>
                                </MDBox>
                              )}
                              <img
                                src={item.postDetails.photo}
                                height="100%"
                                width="100%"
                                alt="picture"
                              />
                            </MDBox>
                          ))}
                        </MDBox>
                      ) : (
                        <MDBox sx={{ textAlign: "center" }}>
                          <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                            No NFT Minted Yet
                          </MDTypography>
                        </MDBox>
                      )}
                    </InfiniteScroll>
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                    <MDBox sx={{ textAlign: "center" }}>
                      <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                        Coming Soon...
                      </MDTypography>
                    </MDBox>
                  </TabPanel>
                </MDBox>
              </Grid>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox
            sx={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SpinLoader />
          </MDBox>
        )}
      </MDBox>

      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Overview;
